export interface ISize2 {
  w: number;
  h: number;
}

export class Size2 {
  static MAX_VALUE = Size2.from(Number.MAX_VALUE, Number.MAX_VALUE);

  static leq(a: ISize2, b: ISize2): boolean {
    return a.w <= b.w && a.h <= b.h;
  }

  static from(w: number, h: number): ISize2 {
    return {
      w,
      h
    }
  }

  static equals(a: ISize2, b: ISize2): boolean {
    return a.w === b.w && a.h === b.h;
  }

  static min(a: ISize2, ...others: ISize2[]): ISize2 {
    let w = a.w;
    let h = a.h;
    for (const o of others) {
      w = Math.min(w, o.w);
      h = Math.min(h, o.h);
    }
    return { w, h }
  }
}
